import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EvkHttpService, EvkUpdateServiceBase, TokenStorageService } from '@evomatik/evk-common';

@Injectable({
    providedIn: 'root'
})
export class DiligenciaAsignacionService extends EvkUpdateServiceBase<any> {

    idNegocio: string;
    idDiligenciaConfig: string;

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/asignar';
    }

    constructor(http: EvkHttpService, public tokenStorage: TokenStorageService) {
        super(http);
    }

    evkOnDoneEdit(response) {
    }

    evkOnErrorEdit(response) {
    }

    evkOnBeforeEdit(data: any): Observable<any> {
        console.log("REVISAR IMPLEMENTACION DE OBTENCION DE USERNAME ESTA NO JALA");
        return new Observable(
            (observer) => {
                data.id = this.idNegocio;
                data.idPerfil = localStorage.getItem('idPerfil');
                //data.createdBy = this.tokenStorage.getUsername();
                data.createdBy = '100766';  //<----REVISAR
                data.idDiligenciaConfig = this.idDiligenciaConfig;
                observer.next(data);
            }
        );
    }
}
